<div class="container-fluid basic_table customer-balances-root">
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <header class="report-page-header">
          <a routerLink="/dashboard/merchant-info" [queryParams]="{ openReports: '1' }" class="report-back-link">
            <i class="fa fa-arrow-right" aria-hidden="true"></i>
            {{ translate.instant('merchant-info.common.back') }}
          </a>
          <div class="report-page-heading">
            <h1>{{ translate.instant('customerBalances.title') }}</h1>
            <p class="report-page-sub">{{ translate.instant('customerBalances.subtitle') }}</p>
          </div>
          <div class="report-page-actions">
            <button class="btn btn-sm m-1" (click)="printReport()">
              <i class="fa fa-print mx-1"></i>
              {{ translate.instant('customerBalances.actions.print') }}
            </button>
            <button class="btn btn-sm m-1 btn-danger" (click)="exportToPdf()" [disabled]="!companyId || !fromDate || !toDate">
              <i class="fa fa-file-pdf-o mx-1"></i>
              {{ translate.instant('customerBalances.actions.export_pdf') }}
            </button>
            <button class="btn btn-sm m-1 btn-success" (click)="exportToExcel()">
              <i class="fa fa-file-excel-o mx-1"></i>
              {{ translate.instant('customerBalances.actions.export_excel') }}
            </button>
            <button class="btn btn-sm m-1 btn-outline-warning" (click)="loadCustomerBalances()" [disabled]="!companyId || !fromDate || !toDate">
              <i class="fa fa-refresh mx-1"></i>
              {{ translate.instant('customerBalances.actions.refresh') }}
            </button>
          </div>
        </header>

        <div class="card-body">
          <!-- Company Selection Warning -->
          <div class="alert alert-warning mb-3" *ngIf="!companyId">
            <i class="fa fa-exclamation-triangle mx-2"></i>
            {{ translate.instant('customerBalances.warnings.no_company') }}
          </div>

          <!-- Filters -->
          <div class="cb-toolbar mb-3">
            <div class="cb-dates">
              <div class="cb-field">
                <label class="cb-label">
                  {{ translate.instant('customerBalances.filters.fromDate') }}
                  <span class="text-danger">*</span>
                </label>
                <p-calendar
                  [(ngModel)]="fromDate"
                  styleClass="cb-calendar"
                  inputStyleClass="cb-calendar-input"
                  [showIcon]="true"
                  dateFormat="dd/mm/yy"
                  placeholder="DD/MM/YYYY"
                  [showButtonBar]="true"
                  [showClear]="true"
                  [readonlyInput]="false"
                  [touchUI]="false"
                  [showWeek]="false"
                  [keepInvalid]="true"
                  [selectOtherMonths]="true"
                  appendTo="body"
                  [autoZIndex]="true"
                  [baseZIndex]="11000"
                  [maxDate]="getMaxFromDate()"
                  (ngModelChange)="onFromDateChange($event)"
                  (onInput)="onFromDateInput($event)"
                  (onBlur)="onFromDateBlur($event)">
                </p-calendar>
              </div>
              <div class="cb-field">
                <label class="cb-label">
                  {{ translate.instant('customerBalances.filters.toDate') }}
                  <span class="text-danger">*</span>
                </label>
                <p-calendar
                  [(ngModel)]="toDate"
                  styleClass="cb-calendar"
                  inputStyleClass="cb-calendar-input"
                  [showIcon]="true"
                  dateFormat="dd/mm/yy"
                  placeholder="DD/MM/YYYY"
                  [showButtonBar]="true"
                  [showClear]="true"
                  [readonlyInput]="false"
                  [touchUI]="false"
                  [showWeek]="false"
                  [keepInvalid]="true"
                  [selectOtherMonths]="true"
                  appendTo="body"
                  [autoZIndex]="true"
                  [baseZIndex]="11000"
                  [minDate]="getMinToDate()"
                  (ngModelChange)="onToDateChange($event)"
                  (onInput)="onToDateInput($event)"
                  (onBlur)="onToDateBlur($event)">
                </p-calendar>
              </div>
              <div class="cb-field cb-field--apply">
                <label class="cb-label cb-label-spacer">&nbsp;</label>
                <button
                  type="button"
                  class="cb-apply-btn"
                  (click)="loadCustomerBalances()"
                  [disabled]="!companyId || !fromDate || !toDate || !!dateRangeError"
                  [title]="translate.instant('customerBalances.actions.refresh')">
                  <i class="fa fa-refresh"></i>
                  <span>{{ translate.instant('customerBalances.actions.refresh') }}</span>
                </button>
              </div>
            </div>
            <div class="cb-field cb-field--search">
              <label class="cb-label">{{ translate.instant('customerBalances.search.label') }}</label>
              <input
                type="text"
                class="form-control cb-search-input"
                [(ngModel)]="searchTerm"
                (input)="onSearch()"
                [placeholder]="translate.instant('customerBalances.search.placeholder')"
              />
            </div>
          </div>
          
          <!-- Date Range Error Message -->
          <div class="row mb-2" *ngIf="dateRangeError">
            <div class="col-12">
              <div class="alert alert-danger mb-0" role="alert">
                <i class="fa fa-exclamation-circle mx-2"></i>
                {{ dateRangeError }}
              </div>
            </div>
          </div>

          <!-- Account Type Selection -->
          <div class="row mb-3">
            <div class="col-12">
              <div class="card" style="background-color: #f8f9fa; border: 1px solid #dee2e6;">
                <div class="card-body py-2">
                  <label class="form-label fw-bold mb-2" style="color: grey;">
                    {{ translate.instant('merchant-info.common.accountTypeLabel') }}
                  </label>
                  <div class="d-flex flex-wrap gap-3">
                    <div class="form-check">
                      <input 
                        class="form-check-input" 
                        type="radio" 
                        name="accountType" 
                        id="accountTypeTaxInvoice"
                        [checked]="accountType === false"
                        (change)="accountType = false; onAccountTypeChange()">
                      <label class="form-check-label" for="accountTypeTaxInvoice" style="color: grey; cursor: pointer; margin-left: 8px;">
                        {{ translate.instant('merchant-info.common.accountTypeTaxInvoice') }}
                      </label>
                    </div>
                    <div class="form-check">
                      <input 
                        class="form-check-input" 
                        type="radio" 
                        name="accountType" 
                        id="accountTypeFinancialClaim"
                        [checked]="accountType === true"
                        (change)="accountType = true; onAccountTypeChange()">
                      <label class="form-check-label" for="accountTypeFinancialClaim" style="color: grey; cursor: pointer; margin-left: 8px;">
                        {{ translate.instant('merchant-info.common.accountTypeFinancialClaim') }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Desktop Table View -->
          <div class="table-wrapper card table-responsive d-none d-md-block">
            <table class="balances-table">
              <thead>
                <tr>
                  <th 
                    class="th-sortable" 
                    (click)="onSort('name')"
                    [class.asc]="getSortClass('name') === 'asc'"
                    [class.desc]="getSortClass('name') === 'desc'">
                    {{ translate.instant('customerBalances.table.columns.customer_name') }}
                    <span class="arrow" *ngIf="sortState.key === 'name'">
                      {{ sortState.direction === 'asc' ? '↑' : '↓' }}
                    </span>
                  </th>
                  <th 
                    class="th-sortable" 
                    (click)="onSort('id')"
                    [class.asc]="getSortClass('id') === 'asc'"
                    [class.desc]="getSortClass('id') === 'desc'">
                    {{ translate.instant('customerBalances.table.columns.customer_id') }}
                    <span class="arrow" *ngIf="sortState.key === 'id'">
                      {{ sortState.direction === 'asc' ? '↑' : '↓' }}
                    </span>
                  </th>
                  <th 
                    class="th-sortable text-start" 
                    (click)="onSort('initial_balance')"
                    [class.asc]="getSortClass('initial_balance') === 'asc'"
                    [class.desc]="getSortClass('initial_balance') === 'desc'">
                    {{ translate.instant('customerBalances.table.columns.opening_balance') }}
                    <span class="arrow" *ngIf="sortState.key === 'initial_balance'">
                      {{ sortState.direction === 'asc' ? '↑' : '↓' }}
                    </span>
                  </th>
                  <th 
                    class="th-sortable text-start" 
                    (click)="onSort('debit')"
                    [class.asc]="getSortClass('debit') === 'asc'"
                    [class.desc]="getSortClass('debit') === 'desc'">
                    {{ translate.instant('customerBalances.table.columns.debit') }}
                    <span class="arrow" *ngIf="sortState.key === 'debit'">
                      {{ sortState.direction === 'asc' ? '↑' : '↓' }}
                    </span>
                  </th>
                  <th 
                    class="th-sortable text-start" 
                    (click)="onSort('credit')"
                    [class.asc]="getSortClass('credit') === 'asc'"
                    [class.desc]="getSortClass('credit') === 'desc'">
                    {{ translate.instant('customerBalances.table.columns.credit') }}
                    <span class="arrow" *ngIf="sortState.key === 'credit'">
                      {{ sortState.direction === 'asc' ? '↑' : '↓' }}
                    </span>
                  </th>
                  <th 
                    class="th-sortable text-start" 
                    (click)="onSort('balance')"
                    [class.asc]="getSortClass('balance') === 'asc'"
                    [class.desc]="getSortClass('balance') === 'desc'">
                    {{ translate.instant('customerBalances.table.columns.current_balance') }}
                    <span class="arrow" *ngIf="sortState.key === 'balance'">
                      {{ sortState.direction === 'asc' ? '↑' : '↓' }}
                    </span>
                  </th>
                  <th 
                    class="th-sortable" 
                    (click)="onSort('transactions')"
                    [class.asc]="getSortClass('transactions') === 'asc'"
                    [class.desc]="getSortClass('transactions') === 'desc'">
                    {{ translate.instant('customerBalances.table.columns.movements') }}
                    <span class="arrow" *ngIf="sortState.key === 'transactions'">
                      {{ sortState.direction === 'asc' ? '↑' : '↓' }}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let customer of filteredData">
                  <td>{{ getCustomerName(customer) }}</td>
                  <td class="number">{{ customer.customer_id_number || customer.customer_id }}</td>
                  <td class="number text-start">{{ formatBalance(customer.initial_balance) }}</td>
                  <td class="number text-start">{{ formatBalance(customer.total_debit) }}</td>
                  <td class="number text-start">{{ formatBalance(customer.total_credit) }}</td>
                  <td 
                    class="number text-start" 
                    [class.neg]="customer.final_balance < 0"
                    [class.pos]="customer.final_balance >= 0">
                    <a 
                      class="balance-link" 
                      (click)="onBalanceClick(customer); $event.preventDefault()"
                      [title]="translate.instant('customerBalances.actions.open_statement')"
                      style="cursor: pointer;">
                      {{ formatBalance(customer.final_balance) }}
                    </a>
                  </td>
                  <td class="number">{{ customer.period_transactions }}</td>
                </tr>
                <tr *ngIf="filteredData.length === 0">
                  <td colspan="7" class="text-center">
                    {{ translate.instant('customerBalances.table.empty') }}
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="2" class="text-end fw-bold">
                    {{ translate.instant('customerBalances.table.total.label') }}
                  </td>
                  <td class="number text-start fw-bold">{{ formatBalance(0) }}</td>
                  <td class="number text-start fw-bold">{{ formatBalance(getTotalDebit()) }}</td>
                  <td class="number text-start fw-bold">{{ formatBalance(getTotalCredit()) }}</td>
                  <td 
                    class="number text-start fw-bold"
                    [class.neg]="getTotalBalance() < 0"
                    [class.pos]="getTotalBalance() >= 0">
                    {{ formatBalance(getTotalBalance()) }}
                  </td>
                  <td class="number fw-bold"></td>
                </tr>
              </tfoot>
            </table>
          </div>

          <!-- Mobile Card View -->
          <div class="d-md-none mobile-cards">
            <div 
              class="mcard" 
              *ngFor="let customer of filteredData"
              (click)="onBalanceClick(customer)">
              <div class="left">
                <div class="name">{{ getCustomerName(customer) }}</div>
                <div class="vat">{{ customer.vat_number }}</div>
              </div>
              <div 
                class="balance"
                [class.neg]="customer.balance < 0"
                [class.pos]="customer.balance >= 0">
                <a 
                  class="balance-link" 
                  (click)="onBalanceClick(customer); $event.preventDefault()"
                  [title]="translate.instant('customerBalances.actions.open_statement')"
                  style="cursor: pointer;">
                  {{ formatBalance(customer.balance) }}
                </a>
              </div>
            </div>
            <div *ngIf="filteredData.length === 0" class="text-center p-3">
              {{ translate.instant('customerBalances.table.empty') }}
            </div>
            <div class="total-mobile mt-3 p-2">
              <strong>{{ translate.instant('customerBalances.table.total.label') }}: </strong>
              <span 
                [class.neg]="getTotalBalance() < 0"
                [class.pos]="getTotalBalance() >= 0">
                {{ formatBalance(getTotalBalance()) }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="statementVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="true"
  [style]="{ width: 'min(960px, 96vw)' }"
  [contentStyle]="{ 'max-height': '70vh', overflow: 'auto' }"
  [header]="
    (statementCustomer
      ? (translate.instant('customerBalances.statement.title') + ' — ' + getCustomerName(statementCustomer))
      : translate.instant('customerBalances.statement.title'))
  "
  (onHide)="closeStatement()"
  styleClass="customer-statement-dialog">

  <div class="statement-toolbar" *ngIf="statementCustomer">
    <div class="statement-meta">
      <span *ngIf="fromDate && toDate">
        {{ formatDate(fromDate) }} → {{ formatDate(toDate) }}
      </span>
    </div>
    <button
      type="button"
      class="btn btn-sm btn-danger"
      (click)="downloadStatementPdf()"
      [disabled]="statementLoading">
      <i class="fa fa-file-pdf-o mx-1"></i>
      {{ translate.instant('customerBalances.statement.downloadPdf') }}
    </button>
  </div>

  <div class="statement-state" *ngIf="statementLoading">
    <i class="fa fa-spinner fa-spin"></i>
    {{ translate.instant('customerBalances.statement.loading') }}
  </div>

  <div class="alert alert-danger" *ngIf="!statementLoading && statementError">
    {{ statementError }}
  </div>

  <div class="table-responsive" *ngIf="!statementLoading && !statementError">
    <table class="statement-table">
      <thead>
        <tr>
          <th>{{ translate.instant('customerBalances.statement.columns.date') }}</th>
          <th>{{ translate.instant('customerBalances.statement.columns.document') }}</th>
          <th>{{ translate.instant('customerBalances.statement.columns.type') }}</th>
          <th class="text-start">{{ translate.instant('customerBalances.statement.columns.debit') }}</th>
          <th class="text-start">{{ translate.instant('customerBalances.statement.columns.credit') }}</th>
          <th class="text-start">{{ translate.instant('customerBalances.statement.columns.balance') }}</th>
          <th>{{ translate.instant('customerBalances.statement.columns.actions') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr class="statement-opening">
          <td colspan="5" class="text-end">
            {{ translate.instant('customerBalances.statement.openingBalance') }}
          </td>
          <td class="number text-start">{{ formatStatementAmount(statementInitialBalance, false) }}</td>
          <td></td>
        </tr>
        <tr
          *ngFor="let row of statementRows"
          [class.statement-account-entry]="isAccountEntryRow(row)"
          [class.statement-debit-entry]="isDebitAccountEntry(row)"
          [class.statement-credit-entry]="isCreditAccountEntry(row)">
          <td>{{ row.invoice_date || '—' }}</td>
          <td>
            <span class="doc-num">{{ row.document_number || '—' }}</span>
            <span class="entry-badge" *ngIf="isAccountEntryRow(row)">
              {{ translate.instant('customerBalances.statement.accountEntryBadge') }}
            </span>
          </td>
          <td>{{ getStatementRowTypeLabel(row) }}</td>
          <td class="number text-start">{{ formatStatementAmount(row.formatted_debit_amount) }}</td>
          <td class="number text-start">{{ formatStatementAmount(row.formatted_credit_amount) }}</td>
          <td class="number text-start">{{ formatStatementAmount(row.running_balance, false) }}</td>
          <td>
            <button
              *ngIf="canOpenRowPdf(row)"
              type="button"
              class="btn btn-sm btn-outline-secondary"
              (click)="openRowPdf(row, $event)"
              [title]="translate.instant('customerBalances.statement.openPdf')">
              <i class="fa fa-file-pdf-o"></i>
            </button>
            <span *ngIf="!canOpenRowPdf(row)" class="text-muted">—</span>
          </td>
        </tr>
        <tr *ngIf="!statementRows.length">
          <td colspan="7" class="text-center text-muted py-3">
            {{ translate.instant('customerBalances.statement.empty') }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</p-dialog>

